import { render, staticRenderFns } from "./designatedTraineeDrawer.vue?vue&type=template&id=bf059f0e&scoped=true"
import script from "./designatedTraineeDrawer.vue?vue&type=script&lang=js"
export * from "./designatedTraineeDrawer.vue?vue&type=script&lang=js"
import style0 from "./designatedTraineeDrawer.vue?vue&type=style&index=0&id=bf059f0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf059f0e",
  null
  
)

export default component.exports